import { createSlice } from "@reduxjs/toolkit";
import * as selectors from "./game.selectors";
import {
  FixTileAction,
  GameState,
  GameStatus,
  RotateTileAction,
  SetChosenLevelAction,
  SetFixTilePowerUsedAction,
  SetFreezeTimePowerUsedAction,
  SetGameStatusAction,
  SetIsTimerFrozenAction,
  SetRemainingTimeAction,
  SetRotationsAction,
} from "./game.interfaces";
import * as sagas from "./game.sagas";
import { Level } from "models";

const initialState: GameState = {
  chosenLevel: null,
  rotations: [],
  status: GameStatus.RESET,
  isTimerFrozen: false,
  freezeTimePowerUsed: false,
  fixTilePowerUsed: false,
  remainingTime: 0,
  totalMoves: 0,
};

export const gameStore = createSlice({
  name: "game",
  initialState,
  reducers: {
    setChosenLevel: (state, action: SetChosenLevelAction) => {
      const level = new Level(action.payload);
      state.chosenLevel = level;
      state.rotations = new Array(level.size ** 2).fill(0);
    },
    setGameStatus: (state, action: SetGameStatusAction) => {
      state.status = action.payload;
    },
    rotateTile: (state, action: RotateTileAction) => {
      state.rotations[action.payload].turns += 1;
    },
    setRotations: (state, action: SetRotationsAction) => {
      state.rotations = [...action.payload];
    },
    fixTile: (state, action: FixTileAction) => {
      state.rotations[action.payload.tileIndex].turns = action.payload.turns;
      state.rotations[action.payload.tileIndex].canRotate = false;
    },
    setRemainingTime: (state, action: SetRemainingTimeAction) => {
      state.remainingTime = action.payload;
    },
    decrementTimer: (state) => {
      state.remainingTime -= 1;
    },
    incrementMovesCount: (state) => {
      state.totalMoves += 1;
    },
    setIsTimerFrozen: (state, action: SetIsTimerFrozenAction) => {
      state.isTimerFrozen = action.payload;
    },
    setFreezeTimePowerUsed: (state, action: SetFreezeTimePowerUsedAction) => {
      state.freezeTimePowerUsed = action.payload;
    },
    setFixTilePowerUsed: (state, action: SetFixTilePowerUsedAction) => {
      state.fixTilePowerUsed = action.payload;
    },
    resetGame: (state) => {
      state.chosenLevel = null;
      state.rotations = [];
      state.status = GameStatus.RESET;
      state.isTimerFrozen = false;
      state.freezeTimePowerUsed = false;
      state.fixTilePowerUsed = false;
      state.totalMoves = 0;
    },
  },
});

export { selectors, sagas };
